export const TITULOS_PAGINAS = {
  "": "Inicio de sesión",
  "/registro": "Registro",
  "/legal": "Legal",

  "/inicio": "Inicio",
  "/tickets": "Tickets",
  "/visitantes": "Visitantes",
  "/encomiendas": "Encomiendas",
  "/pqrs": "PQRS",
  "/detalle_pqrs": "Respuestas PQRS",
  "/noticias": "Noticias",
  "/anuncios": "Anuncios",
  "/mis_anuncios": "Mis anuncios",
  "/notificaciones": "Notificaciones",
  "/novedades": "Novedades",
  "/usuarios": "Usuarios",
  "/censo": "Censo",
  "/informe_censo": "Informes de censo",
  "/estadistica_censo": "Estadística de censo",
  "/reservas": "Reservas",
  "/crear_reserva": "Crear reserva",
  "/zonas_sociales": "Zonas sociales",
  "/clientes": "Clientes",
  "/rondas": "Rondas",
  "/analisis_rondas": "Análisis de rondas",
  "/tutoriales": "Tutoriales",
  "/gps": "GPS",
  "/eventos": "Eventos",
  "/estadistica": "Estadística",
  "/seguimiento": "Seguimiento",
  "/sos": "SOS",
  "/sos_prueba": "Prueba de SOS",
  "/panico": "Pánico",
  "/inmuebles": "Inmuebles",
  "/rating": "Calificaciones",
  "/logs": "Logs",
  "/logs_grafica": "Estadística de logs",
  "/cartera": "Cartera",
  "/mi_cartera": "Mi cartera",
  "/unidades_vivienda": "Unidades de vivienda",
  "/actividades": "Actividades",
  "/estadistica_actividades": "Estadística de actividades",
  "/perfil_copropiedad": "Perfil de copropiedad",
  "/cobro_parqueaderos": "Cobro parqueaderos",
  "/configuracion_modulos": "Configuración de módulos",
  "/correos_excluidos": "Correos excluidos",
  "/inmuebles_administrativos": "Inmuebles administrativos",
  "/documentos": "Documentos",
  "/chats": "Chats",
  "/mi_propiedad": "Mi propiedad",
  "/configuraciones_globales": "Configuraciones globales",
  "/cuenta_correo": "Cuenta de correo",
  "/fiesta": "Safari con Coordinar",
  "/estadistica_fiesta": "Informe Safari con Coordinar",
};

export const TITULO_BASE = "CoordiPH Web";
export const TITULO_NO_ENCONTRADO = "Página no encontrada";

export function obtenerTitulo(pathname) {
  const ruta = pathname === "/" ? "" : pathname.replace(/\/+$/, "");
  const titulo = TITULOS_PAGINAS[ruta] ?? TITULO_NO_ENCONTRADO;
  return `${TITULO_BASE} | ${titulo}`;
}
